<template>
  <div class="home-c" id="home">
    <div class="bg">
      <img class="img1" src="@/assets/img/home/bg.png">
      <img class="img2" src="@/assets/img/home/bg-h5.png">
      <div class="shadow"></div>
    </div>
    <div class="con">
      <div class="c-box">
        <div class="img-box">
          <div class="trans-icon">
            <img src="@/assets/img/home/start.png">
          </div>
          <img src="@/assets/img/header/logo.png">
        </div>
        <span class="t1">Singapore</span>
        <span class="t2 gold-text">Learning Hub</span>
        <p class="des"><span>{{ $t('home.p1') }}</span>{{ $t('home.p2') }}<br>{{ $t('home.p3') }} </p>
        <div class="price">
          <p class="p1 gold-text">{{ $t('home.p4') }} | 800 USDC</p>
          <p class="p2">{{ $t('home.p5') }}%</p>
        </div>
        <div class="btns">
          <a class="btn1 btn" href="#node">{{ $t('home.p6') }}</a>
          <a class="btn2 btn" href="#share">{{ $t('home.p7') }}</a>
        </div>
        <div class="bot-text">
          <div class="b-t-c">B</div>
          {{ $t('home.p8') }}
        </div>
      </div>
    </div>
    <div class="more">
      {{ $t('home.p9') }}
      <i class="el-icon-arrow-down"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
}
</script>

<style scoped lang="scss">
@import './style.scss';
@import './h5-style.scss';
</style>
